function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "8",
  height: "14",
  viewBox: "0 0 8 14",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), React.createElement("defs", null, React.createElement("path", {
  d: "M18.41 14.056l-5.28-5.661A1.205 1.205 0 0012.246 8c-.332 0-.65.142-.884.395a1.405 1.405 0 000 1.882l4.408 4.727-4.408 4.726a1.405 1.405 0 000 1.883 1.203 1.203 0 001.768 0l5.28-5.661c.235-.25.368-.592.368-.948s-.133-.697-.369-.948z",
  id: "path-arrow-right"
})), React.createElement("use", {
  fill: "currentColor",
  xlinkHref: "#path-arrow-right",
  transform: "translate(-11 -8)",
  fillRule: "evenodd"
})));